<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2035_1077)">
<rect width="28" height="28" fill="#54FFF5"/>
<g filter="url(#filter0_f_2035_1077)">
<path d="M1.4745 21.7215C-3.20763 34.8943 21.838 31.1738 34.9461 27.667C48.3618 23.2148 39.0892 3.58946 29.4673 3.15512C19.8454 2.72078 30.6603 12.2298 22.487 14.9457C14.3138 17.6617 7.32718 5.2554 1.4745 21.7215Z" fill="white"/>
</g>
<g filter="url(#filter1_f_2035_1077)">
<path d="M9.35304 -5.01224C6.89695 -11.7228 -1.85032 -2.62489 -5.91695 2.76289C-9.79601 8.62359 0.329333 13.6881 4.3009 10.9412C8.27247 8.19428 0.850517 7.65982 3.21262 4.08788C5.57471 0.515936 12.4231 3.37596 9.35304 -5.01224Z" fill="#00FFF0" fill-opacity="0.67"/>
</g>
<g filter="url(#filter2_f_2035_1077)">
<path d="M10.5526 24.6538C7.20255 13.3816 -7.22752 19.3178 -14.0238 23.6949C-20.5612 28.8777 -5.03885 43.7862 1.4081 43.0236C7.85506 42.2609 -3.76361 35.7709 0.217505 32.6105C4.19862 29.4501 14.7402 38.7441 10.5526 24.6538Z" fill="#9D81FF"/>
</g>
<g filter="url(#filter3_f_2035_1077)">
<path d="M30.8569 -11.7432C23.6302 -20.3486 13.285 -13.2326 9.0158 -8.59889C5.28001 -3.35325 24.5301 6.25816 29.8727 4.611C35.2153 2.96383 22.5873 -0.444505 24.8607 -3.64236C27.1341 -6.84022 39.8904 -0.986489 30.8569 -11.7432Z" fill="#4D94FF"/>
</g>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.1926 16.7164H14.9487L9.53847 11.2712L15.0183 5.826L16.5107 4.375H11.574L5.28676 10.6944C4.96947 11.0129 4.9711 11.5283 5.29001 11.8452L10.1926 16.7164ZM13.0517 11.284H13.0151L13.0513 11.2836L13.0517 11.284ZM13.0517 11.284L18.4616 16.7288L12.9818 22.174L11.4893 23.625H16.426L22.7133 17.306C23.0305 16.9875 23.0289 16.4721 22.71 16.1552L17.8074 11.284H13.0517Z" fill="black"/>
</g>
<defs>
<filter id="filter0_f_2035_1077" x="-9.87006" y="-7.62861" width="62.2955" height="49.3764" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="5.38462" result="effect1_foregroundBlur_2035_1077"/>
</filter>
<filter id="filter1_f_2035_1077" x="-17.5556" y="-18.1559" width="38.4557" height="40.6342" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="5.38462" result="effect1_foregroundBlur_2035_1077"/>
</filter>
<filter id="filter2_f_2035_1077" x="-26.3676" y="7.39678" width="48.6556" height="46.4252" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="5.38462" result="effect1_foregroundBlur_2035_1077"/>
</filter>
<filter id="filter3_f_2035_1077" x="-2.2309" y="-26.5524" width="47.0521" height="42.1205" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="5.38462" result="effect1_foregroundBlur_2035_1077"/>
</filter>
<clipPath id="clip0_2035_1077">
<rect width="28" height="28" fill="white"/>
</clipPath>
</defs>
</svg>
